import { shippingCost } from "@/event/order/data/shippingCost"
import { deliveryBus } from "@/event/order/deliveryBus"
import { addressSelectedOrderHappy } from "@/happyTheme/event/order/addressSelectedOrderHappy"
import { totalPrice } from "@/utils/price/totalPrice"

export function handleShippingCostHappy() {
    const address = addressSelectedOrderHappy.value

    if (!address || !address.value || Number(address.data.address_id) === 0) return

    const totalPriceOutShippingCost = Number(totalPrice.value) - Number(shippingCost.value)

    if (
        Number(addressSelectedOrderHappy.value.free_price) === 0 ||
        Number(totalPriceOutShippingCost) < Number(addressSelectedOrderHappy.value.free_price)
    ) {
        shippingCost.value = Number(addressSelectedOrderHappy.value.price)
        deliveryBus.value = true
    } else if (
        Number(totalPriceOutShippingCost) > Number(addressSelectedOrderHappy.value.free_price)
    ) {
        shippingCost.value = 0
        deliveryBus.value = false
    }

}